"use client";

import { c as _c } from "react/compiler-runtime";
import { useInView, useMotionValue, useSpring } from "motion/react";
import { useEffect, useRef } from "react";
import { cn } from "@/utils";
export function NumberTicker(t0) {
  const $ = _c(28);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      startValue: t1,
      direction: t2,
      delay: t3,
      className,
      decimalPlaces: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = value;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    value = $[7];
  }
  const startValue = t1 === undefined ? 0 : t1;
  const direction = t2 === undefined ? "up" : t2;
  const delay = t3 === undefined ? 0 : t3;
  const decimalPlaces = t4 === undefined ? 0 : t4;
  const ref = useRef(null);
  const motionValue = useMotionValue(direction === "down" ? value : startValue);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      damping: 60,
      stiffness: 100
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const springValue = useSpring(motionValue, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      once: true,
      margin: "0px"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const isInView = useInView(ref, t6);
  let t7;
  let t8;
  if ($[10] !== delay || $[11] !== direction || $[12] !== isInView || $[13] !== motionValue || $[14] !== startValue || $[15] !== value) {
    t7 = () => {
      if (isInView) {
        const timer = setTimeout(() => {
          motionValue.set(direction === "down" ? startValue : value);
        }, delay * 1000);
        return () => clearTimeout(timer);
      }
    };
    t8 = [motionValue, isInView, delay, value, direction, startValue];
    $[10] = delay;
    $[11] = direction;
    $[12] = isInView;
    $[13] = motionValue;
    $[14] = startValue;
    $[15] = value;
    $[16] = t7;
    $[17] = t8;
  } else {
    t7 = $[16];
    t8 = $[17];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[18] !== decimalPlaces || $[19] !== springValue) {
    t9 = () => springValue.on("change", latest => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat("en-US", {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces
        }).format(Number(latest.toFixed(decimalPlaces)));
      }
    });
    t10 = [springValue, decimalPlaces];
    $[18] = decimalPlaces;
    $[19] = springValue;
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  useEffect(t9, t10);
  let t11;
  if ($[22] !== className) {
    t11 = cn(className);
    $[22] = className;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== props || $[25] !== startValue || $[26] !== t11) {
    t12 = <span ref={ref} className={t11} {...props}>{startValue}</span>;
    $[24] = props;
    $[25] = startValue;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}